// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Button, Icon, IconType } from '@lmc/ui-kit'
import { css, StyleSheet } from 'aphrodite/no-important'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormInput } from '../../../LEGACY/elemental'

const handleSave = async (onSaveTitle, setIsEditable, newTitle) => {
  await onSaveTitle(newTitle)
  setIsEditable(false)
}

export default function EditableTitle(props) {
  const { title, titleStyles, onSaveTitle, containerStyles } = props
  const [isEditable, setIsEditable] = useState(false)
  const [newTitle, setNewTitle] = useState()

  useEffect(() => {
    setNewTitle(title)
  }, [title])

  return isEditable ? (
    <div style={{ ...styles.titleContainer, ...containerStyles }}>
      <FormInput
        size="default"
        type="text"
        value={newTitle}
        style={styles.editTitle}
        onChange={(e) => {
          setNewTitle(e.target.value)
        }}
      />

      <Button
        onClick={() => {
          setIsEditable(false)
          setNewTitle(title)
        }}
      >
        Cancel
      </Button>
      <Space />
      <Button
        disabled={newTitle === ''}
        onClick={() => {
          handleSave(onSaveTitle, setIsEditable, newTitle)
          setNewTitle(title)
        }}
        variant="primary"
      >
        Save
      </Button>
    </div>
  ) : (
    <div style={{ ...styles.titleContainer, ...containerStyles }}>
      <h2 style={titleStyles}>{title}</h2>
      <Button
        className={css(classes.titleEditBtn)}
        onClick={() => {
          setIsEditable(true)
        }}
      >
        <Icon customIcon={IconType.Pencil} size={14} />
      </Button>
    </div>
  )
}

const classes = StyleSheet.create({
  titleEditBtn: {
    background: 'transparent !important',
    position: 'relative',
    top: -9,
    height: 30,
    color: `${colors.black} !important`,
    marginLeft: 6,
    transition: 'all .2s ease',
    ':hover': {
      background: `${colors.orange} !important`,
      color: `${colors.white} !important`
    }
  }
})

const styles = {
  editTitle: {
    borderColor: null,
    height: 32,
    width: '100%',
    marginRight: 10
  },
  titleContainer: {
    display: 'flex'
  }
}

const Space = styled.span`
  display: inline-block;
  width: 10px;
`
